export const CREATE_CALENDER= 'common@create-calender';
export const DELETE_CALENDER= 'common@delete-calender';
export const UPDATE_CALENDER= 'common@update-calender';